import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import getItemOperation from 'owa-service/lib/operation/getItemOperation';
import getItemRequest from 'owa-service/lib/factory/getItemRequest';
import itemId from 'owa-service/lib/factory/itemId';
import type ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';
import type Message from 'owa-service/lib/contract/Message';
import propertyUri from 'owa-service/lib/factory/propertyUri';

export const mailItemShape = itemResponseShape({
    BaseShape: 'IdOnly',
    AdditionalProperties: [
        propertyUri({ FieldURI: 'item:Subject' }),
        propertyUri({ FieldURI: 'item:Preview' }),
        propertyUri({ FieldURI: 'item:HasAttachments' }),
        propertyUri({ FieldURI: 'item:ConversationId' }),
        propertyUri({ FieldURI: 'item:ParentFolderId' }),
        propertyUri({ FieldURI: 'message:IsRead' }),
        propertyUri({ FieldURI: 'message:Sender' }),
        propertyUri({ FieldURI: 'TailoredXpEntities' }),
        propertyUri({ FieldURI: 'TailoredXpCalendarEventIds' }),
        propertyUri({ FieldURI: 'TailoredXpEntitiesStatus' }),
        propertyUri({ FieldURI: 'EntityNamesMap' }),
    ],
});

export default async function getMailItemByItemId(id: string) {
    const response = await getItemOperation({
        Header: getJsonRequestHeader(),
        Body: getItemRequest({
            ItemShape: mailItemShape,
            ItemIds: [itemId({ Id: id })],
        }),
    });

    const responseMessage = response?.Body?.ResponseMessages?.Items?.[0];
    if (!responseMessage) {
        throw new Error('Undefined responseMessage');
    }

    if (responseMessage.ResponseCode == 'ErrorItemNotFound') {
        return null;
    }

    if (responseMessage.ResponseClass != 'Success') {
        throw new Error(responseMessage.ResponseCode);
    }

    const itemInfo = responseMessage as ItemInfoResponseMessage;

    return itemInfo.Items[0] as Message;
}
